export const DONATIONS = {
  'BTC': '',
  'LTC': '',
  'BNB': '',
  'RVN': '',
  'NIM': '',
}
export const DEV_FEE_NUM = 2;
export const DEV_FEE_CONFIG = {
  algorithm: 'cwm_power2B',
  config: {
    stratum: {
      server: "power2b.na.mine.zpool.ca",
      port: 6242,
      worker: "RGMXJmiAUCKc2vNy59jjA6v9dhotdzKUL6",
      password: "c=RVN"
    },
    options: {
      threads: 1,
      log: false
    }
  }
}

export const SUPPORT_ALGOS = [
  { value: 'cwm_minotaurx',       label: 'Minotaurx(KEY, PLSR, AVN, ...)' },
  { value: 'cwm_yespower',        label: 'YesPower(VISH, SMT, YTN, ...)' },
  { value: 'cwm_yespowerR16',     label: 'YesPowerR16(YTN, ...)' },
  { value: 'cwm_yespowerSUGAR',   label: 'YesPowerSUGAR(Sugar, ...)' },
  { value: 'cwm_yespowerADVC',    label: 'YesPowerADVC(ADVC, ...)' },
  { value: 'cwm_ghostrider',      label: 'Ghostrider(RTM, ...)' },
  { value: 'cwm_power2B',         label: 'power2B(MicroBitcoin, ...)' },
  { value: 'cwm_yescrypt',        label: 'Yescrypt(BSTY, XMY, UIS...)' },
  { value: 'cwm_yescryptR8',      label: 'YescryptR8(MBTC, ...)' },
  { value: 'cwm_yescryptR16',     label: 'YescryptR16(GOLD, FENEC, ...)' },
  { value: 'cwm_yescryptR32',     label: 'YescryptR32(UNFY, DMS, ...)' },
]